<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-toolbar(flat dense color="cyan")
          v-icon.white--text fa-search
          v-toolbar-title.white--text {{$t('order.search')}}
    v-layout(row wrap)
      v-flex(xs12 sm6 md4)
        v-text-field.ma-0(
          placeholder="検索: 見積番号/営業担当/業務担当/顧客担当"
          hide-details
          color="info"
          type="text"
          v-model="keyword"
          autocapitalize="off"
          prepend-icon="search"
          append-outer-icon="refresh"
          @click:append-outer="search"
          @keyup.enter="search"
        )
    transition-group(name="flip-list" tag="div" class="layout row wrap")
      div.flex.xs12.sm6.md4.lg3.flip-list-item(v-for="order in filteredList" :key="order.token")
        list-item(
          :token="order.token"
          :requested="!order.accepted && !order.settled && !order.arranged && !order.completed"
          :estimated="order.accepted && !order.settled && !order.arranged && !order.completed"
          :settled="order.accepted && order.settled && !order.arranged && !order.completed"
          :arranged="order.accepted && order.settled && order.arranged && !order.completed"
          :completed="order.accepted && order.settled && order.arranged && order.completed"
          :search="resolveSearchMode(order)"
        )
</template>

<script>
import ListItem from '../Components/ListItem'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    ListItem
  },
  data () {
    return {
      keyword: ''
    }
  },
  created () {
    this.clearList()
  },
  beforeDestroy () {
    this.clearList()
  },
  computed: {
    ...mapGetters('app/list', ['list']),
    filteredList () {
      return this.list
    }
  },
  methods: {
    ...mapActions('app/list', ['clearList', 'setList']),
    search () {
      const query = this.$url.buildQuery({
        keyword: this.keyword || ''
      })
      this.$ajax.get(`order/by_tags?${query}`).then(response => {
        this.setList(response.data.list)
      })
    },
    resolveSearchMode (order) {
      // requested
      if (
        !order.accepted &&
        !order.settled &&
        !order.arranged &&
        !order.completed
      ) {
        return {
          enabled: true,
          color: 'accent white--text',
          status: this.$t('order.estimated')
        }
      }
      // estimated
      if (
        order.accepted &&
        !order.settled &&
        !order.arranged &&
        !order.completed
      ) {
        return {
          enabled: true,
          color: 'pink darken-1 white--text',
          status: this.$t('order.estimated')
        }
      }
      // settled
      if (
        order.accepted &&
        order.settled &&
        !order.arranged &&
        !order.completed
      ) {
        return {
          enabled: true,
          color: 'deep-purple darken-1 white--text',
          status: this.$t('order.settled')
        }
      }
      // arranged
      if (
        order.accepted &&
        order.settled &&
        order.arranged &&
        !order.completed
      ) {
        return {
          enabled: true,
          color: 'amber darken-3 white--text',
          status: this.$t('order.arranged')
        }
      }
      // completed
      if (
        order.accepted &&
        order.settled &&
        order.arranged &&
        order.completed
      ) {
        return {
          enabled: true,
          color: 'blue-grey lighten-2 white--text',
          status: this.$t('order.completed')
        }
      }
      return {
        enabled: true,
        color: 'red white--text',
        status: '不明'
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.flip-list-item {
  transition: transform 0.5s;
}

.flip-list-enter, .flip-list-leave-to {
  opacity: 0;
}

.flip-list-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/app/pages/List/Search/index.vue